import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './hero-block.module.scss';
import BookingForm from './components/BookingForm/BookingForm';
import UpliftWidget from '@/components/UpliftWidget/UpliftWidget';
import { UPLIFT_INSTANT_ESTIMATE_GUID } from '@/config/uplift.config';
import { HeroBlockType } from '@/types/heroBlock.types';

const HeroBlock: NextPage<HeroBlockType> = ({
  className = '',
  device = 'Default',
  form = 'On',
  showForm = true,
  formVariant = 'uplift',
  upliftGuid = UPLIFT_INSTANT_ESTIMATE_GUID,
  upliftTitle = 'Book your flight now',
  title = "Discover the World's Most Amazing Places",
  description = 'Private Jet Charter Flights & More',
  backgroundImage = '/img/heroBlock/bg.webp',
}) => {
  return (
    <section
      className={[styles.heroblock, className].join(' ')}
      data-device={device}
      data-form={form}
      data-show-form={showForm}
    >
      <Image
        src={backgroundImage}
        alt=""
        fill
        priority
        fetchPriority="high"
        sizes="100vw"
        className={styles.heroBgImage}
      />
      <div className="container">
        <div className={styles.herocontainer}>
          <div className={styles.text}>
            <h1 className={styles.title}>{title}</h1>
            <h2
              className={styles.deskriptor}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
          {showForm &&
            (formVariant === 'uplift' ? (
              <div className={styles.upliftCard}>
                {upliftTitle && (
                  <h3 className={styles.upliftTitle}>{upliftTitle}</h3>
                )}
                <UpliftWidget guid={upliftGuid} />
              </div>
            ) : (
              <BookingForm />
            ))}
        </div>
      </div>
    </section>
  );
};

export default HeroBlock;
